import PropTypes from "prop-types";
import { Redirect, Route } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoutes = ({ component: Component, name, ...restOfProps }) => {
  const state = useSelector((state) => state.menus);
  const isAllowed = state?.data?.allowedMenus?.includes(name) || false;
  return (
    <Route
      {...restOfProps}
      render={(props) =>
        isAllowed ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  );
};

export default ProtectedRoutes;

ProtectedRoutes.propTypes = {
  component: PropTypes.elementType,
  name: PropTypes.string,
};
